module.exports = __webpack_public_path__ + "9bbe7464.svg";